import { DownloadSimple } from '@phosphor-icons/react';
import { Flex, Skeleton, Space, Typography } from 'antd';
import { COLOR } from '@styles/theme';

type InboundShipmentAppHeaderLeadProps = {
  displayId?: string | null;
  loading?: boolean;
};

/** App header: Inbound page title + shipment display ID. */
export function InboundShipmentAppHeaderLead({
  displayId,
  loading = false,
}: InboundShipmentAppHeaderLeadProps) {
  return (
    <Flex
      align="center"
      gap={12}
      wrap="nowrap"
      style={{ minWidth: 0, maxWidth: '100%', height: '100%' }}
    >
      {loading ? (
        <Skeleton.Input active size="small" style={{ width: 168, minWidth: 120 }} />
      ) : displayId ? (
        <Space size="small" align="center">
          <DownloadSimple size={20} color={COLOR.black} />
          <Typography.Text
            strong
            style={{
              fontSize: 14,
              lineHeight: 1,
              maxWidth: 280,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {displayId}
          </Typography.Text>
        </Space>
      ) : null}
    </Flex>
  );
}
